import { render, staticRenderFns } from "./Service_Gallery.vue?vue&type=template&id=fe685644&scoped=true&"
import script from "./Service_Gallery.vue?vue&type=script&lang=js&"
export * from "./Service_Gallery.vue?vue&type=script&lang=js&"
import style0 from "./Service_Gallery.vue?vue&type=style&index=0&id=fe685644&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe685644",
  null
  
)

export default component.exports